<p-card class="w-full p-2 m-4 md:w-6/12">
  <ng-template #title> Payment Information </ng-template>
  <ul class="p-0 m-0 list-none border-top-1 surface-border">
    <li class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold md:w-2/12 text-300">Current Balance</div>
      <div
        class="w-8/12 md:w-10/12 md:flex-order-0 flex-order-1 text-400">
        {{ this.currentBalance | currency : "USD" }}
      </div>
    </li>
    <li *ngIf="this.hasSubscriptions" class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-4/12 font-semibold text-300 md:w-2/12">Monthly Price</div>
      <div class="w-8/12 text-400 md:w-10/12">
        {{
          (customer_overview()?.subscriptions)!.data[0]!.actual_amount
            | currency : "USD"
        }}
      </div>
    </li>
    <li *ngIf="this.hasSubscriptions" class="flex flex-wrap px-2 py-3 align-items-center surface-ground">
      <div class="w-full text-400 md:w-10/12">
        <p class="flex items-center gap-1 next-invoice sm:pt-0">
          <img
            src="/dashboard/overview/calendar.svg"
            alt="calender"
            class="pb-2 sm:pb-0" />
          Next invoice scheduled for
          <strong>
            {{ (customer_overview()?.subscriptions)!.data[0].next_due | date }}
          </strong>
        </p>
      </div>
    </li>
  </ul>
  <ng-template #footer>
    <div class="flex flex-wrap w-full p-4 mt-4 font-semibold">
      <p-button
      label="Make a Payment"
      pRipple
      icon="pi pi-wallet"
      class="w-full p-4 m-2 text-center rounded-md lg:w-2/12 bg-primary-500"
      (onClick)="makePayment()" />
      
    <p-button
      label="Latest Invoice"
      pRipple
      icon="pi pi-wallet"
      class="w-full p-4 m-2 text-center rounded-md lg:w-2/12 bg-primary-500"
      (onClick)="latestInvoice()" />
    </div>
  </ng-template>
</p-card>